import { useEffect, useState } from "react";
import { AlertTriangle } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "../../lib/api";

export function MediaHealthBanner() {
  const [d, setD] = useState(null);
  const [open, setOpen] = useState(false);
  const check = () => api.get("/admin/media/check").then((r) => setD(r.data)).catch(() => {});
  useEffect(() => { check(); }, []);
  const used = d ? d.missing.filter((m) => m.used_in.length) : [];
  const unused = d ? d.missing.length - used.length : 0;
  const cleanup = async () => {
    if (!window.confirm(`Remove ${unused} missing image record(s) that are not used anywhere?`)) return;
    try { const r = await api.post("/admin/media/remove-unused-missing"); toast.success(`Removed ${r.data.removed} unused record(s)`); check(); } catch (e) { toast.error(errMsg(e)); }
  };
  if (!d || (d.storage.persistent && !d.storage.overridden && !used.length && !unused)) return null;
  return (
    <div className="border-b border-amber-300 bg-amber-50 px-5 py-2 text-sm text-amber-900" role="status" data-testid="media-health-banner">
      <AlertTriangle size={16} className="mr-1 inline" aria-hidden="true" />
      {!d.storage.persistent && <b data-testid="media-not-persistent">Uploads are not persistent on this server. </b>}
      {d.storage.overridden && <span>The server setting STORAGE_BACKEND=local was ignored, so new uploads are stored permanently in the database. </span>}
      {used.length > 0 && <>
        <b data-testid="media-missing-count">{used.length} image(s) in use are missing their file – please re-upload.</b>{" "}
        <button type="button" className="underline" onClick={() => setOpen(!open)} data-testid="media-check-toggle">{open ? "Hide" : "Check media"}</button>
        {open && <ul className="mt-1 list-disc pl-6 text-xs" data-testid="media-missing-list">{used.map((m) => (
          <li key={m.id}>{m.filename || m.id} (uploaded {(m.created_at || "").slice(0, 10)}) – used in {m.used_in.join("; ")}</li>))}</ul>}
      </>}
      {unused > 0 && <> <button type="button" className="underline" onClick={cleanup} data-testid="media-remove-unused-btn">Remove {unused} unused missing record(s)</button></>}
    </div>
  );
}
